import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto"
    },
    attrs: {
      "data-sign": "inbound_plan_form",
      "model": _vm.formData,
      "rules": _vm.formDataRule
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "columns": _vm.columns,
      "data-source": _vm.formData.list,
      "data-sign": "inbound_plan_form_table",
      "row-key": "receiving_code"
    },
    scopedSlots: _vm._u([{
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_name) + "] ")];
      }
    }, {
      key: "index",
      fn: function (ref) {
        var index = ref.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "deliver_time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.deliver_time)))]), record.deliver_time === _vm.lastMoth ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(_vm.t('填写实际发货体积')))]) : _vm._e()]);
      }
    }, {
      key: "deliver_volume",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "list." + index + ".deliver_volume",
            "rules": _vm.formDataRule['list.*.deliver_volume']
          }
        }, [_c('my-input', {
          model: {
            value: record.deliver_volume,
            callback: function ($$v) {
              _vm.$set(record, "deliver_volume", $$v);
            },
            expression: "record.deliver_volume"
          }
        })], 1)];
      }
    }, {
      key: "remark",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "list." + index + ".remark",
            "rules": _vm.formDataRule['list.*.remark']
          }
        }, [_c('my-input', {
          attrs: {
            "maxLength": 100
          },
          model: {
            value: record.remark,
            callback: function ($$v) {
              _vm.$set(record, "remark", $$v);
            },
            expression: "record.remark"
          }
        })], 1)];
      }
    }])
  })], 1)], 1), _c('footer-tool', [_c('a-button', {
    staticClass: "mr-10",
    attrs: {
      "data-permission": "inbound_plan_add_cancel",
      "id": "inbound_plan_add_cancel",
      "data-sign": "inbound_plan_form_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'InboundPlanPage',
          params: {
            closeCurrent: '1'
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "inbound_plan_add_save",
      "id": "inbound_plan_add_save",
      "data-sign": "inbound_plan_form_confirm",
      "loading": _vm.saveLoading,
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };